import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { CdnImg } from '@webplatform/cdn-image';
import UiSectionTitle from '~/components/ui/UiSectionTitle.vue';
import { useBreakpoint } from '~/composables';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CtaSectionWithBackground',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { data: any };



const { isBiggerThanBreakpoint: mdAndUp } = useBreakpoint('md');
const banner = computed(() => {
  let image = props.data.banner?.src;
  if (!image) return undefined;

  if (!mdAndUp.value) {
    image =
      props.data.banner.mobile && props.data.banner.mobile.src
        ? props.data.banner.mobile.src
        : props.data.banner.src;
  }
  return image;
});

return { __sfc: true,props, mdAndUp, banner, CdnImg, UiSectionTitle }
}

})